<section data-component="disclosure-banner"> 
    <div class="container no-padding disclosureWrapper" *ngIf="primaryDisclosureArray.length > 0 || secondaryDisclosureArray.length > 0 || flexDisclosureArray.length > 0"> 

        <div class="primaryDisclosureWrapper" *ngIf="primaryDisclosureArray.length > 0"> 
            <p class="disclosureText" *ngFor="let primaryDisclosure of primaryDisclosureArray" [innerHTML]="primaryDisclosure"> 
            </p> 
        </div> 
        <div class="secondaryDisclosureWrapper" *ngIf="secondaryDisclosureArray.length > 0"> 
            <p class="disclosureText" *ngFor="let secondaryDisclosure of secondaryDisclosureArray" [innerHTML]="secondaryDisclosure"> 
            </p> 
        </div> 
        <div class="flexDisclosureWrapper" *ngIf="flexDisclosureArray.length > 0"> 
            <p class="disclosureText" *ngFor="let flexDisclosure of flexDisclosureArray" [innerHTML]="flexDisclosure"> 
            </p> 
        </div> 
    </div> 
</section>